export const NavbarScroll = {
  mounted() {
    this.el.addEventListener("enaia:navbarScrollToPartnershipInvite", (e) => {
      const el = document.getElementById(
        `partnership-invite-${e.detail.invite_id}`,
      )

      // timeout is needed for the scroll to work
      setTimeout(function () {
        el.scrollIntoView()
        el.classList.add("border")
      }, 200)
    })
  },
}
